'use client';

import React, {useState} from 'react';
import {ChevronDown, ChevronUp} from "lucide-react";

interface CarSpecsTableProps {
    car: any;
}

const MotoreIcon = (
    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M9.47368 0.605255C10.0551 0.605255 10.5263 1.07654 10.5263 1.65789C10.5263 2.23923 10.0551 2.71052 9.47368 2.71052H8.42105V3.76315H11.3304C11.6573 3.76315 11.9796 3.83924 12.272 3.98541L15.6783 5.6886C16.3916 6.04521 16.8421 6.77419 16.8421 7.5716V10.0789H17.8947V9.02631C17.8947 8.44494 18.366 7.97368 18.9474 7.97368C19.5287 7.97368 20 8.44494 20 9.02631V13.2368C20 13.8182 19.5287 14.2895 18.9474 14.2895C18.366 14.2895 17.8947 13.8182 17.8947 13.2368V12.1842H16.8421V13.7631C16.8421 14.4258 16.5301 15.0498 16 15.4474L12.4913 18.0789C12.1268 18.3522 11.6836 18.5 11.2281 18.5H2.10526C0.942558 18.5 0 17.5575 0 16.3947V5.86841C0 4.70571 0.942558 3.76315 2.10526 3.76315H6.31579V2.71052H5.26316C4.68181 2.71052 4.21053 2.23923 4.21053 1.65789C4.21053 1.07654 4.68181 0.605255 5.26316 0.605255H9.47368ZM8.43632 7.59737C7.9734 7.31963 7.38283 7.43917 7.06135 7.85679L6.99212 7.95841L5.42273 10.5741C5.01882 11.2473 5.45929 12.0945 6.21287 12.1776L6.33438 12.1842H7.61453L6.99212 13.2216C6.69301 13.7201 6.85465 14.3666 7.35316 14.6658C7.81608 14.9435 8.4066 14.824 8.72813 14.4064L8.79737 14.3047L10.3667 11.689C10.7706 11.0159 10.3302 10.1686 9.57657 10.0856L9.45505 10.0789H8.17495L8.79737 9.04157C9.09642 8.54304 8.93484 7.89648 8.43632 7.59737Z"
              fill="black"/>
    </svg>
)

const CarrozzeriaIcon = (
    <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M8.8908 0C10.6207 0 12.0423 0.59235 13.008 1.15858C14.3161 1.92551 14.818 3.36821 14.818 4.65685V6.3677C15.2104 6.61981 15.5753 6.86714 15.8999 7.09455L16.4581 7.49393L16.5567 7.56626C16.8446 7.77821 17.1306 7.99312 17.4091 8.2177C17.83 8.5582 17.9022 9.1982 17.5652 9.6247C17.2243 10.0559 16.6029 10.1259 16.1768 9.781C15.7372 9.4264 15.2796 9.0934 14.818 8.7689V15.5858C14.818 16.7565 14.3586 17.8793 13.5408 18.7071C12.723 19.5349 11.6139 20 10.4574 20H7.32434C6.16777 20 5.05863 19.5349 4.24084 18.7071C3.42306 17.8793 2.96364 16.7565 2.96364 15.5858V8.7689C2.50208 9.0934 2.04456 9.4263 1.60504 9.7809C1.17901 10.1257 0.557284 10.0559 0.21651 9.6247C-0.124314 9.1934 -0.0552425 8.5641 0.370785 8.2191C0.650756 7.99524 0.936408 7.77868 1.22494 7.56626L1.64605 7.26115C2.02556 6.9905 2.47319 6.68284 2.96364 6.3677V4.65685C2.96364 3.36821 3.46562 1.92551 4.77365 1.15858C5.73936 0.59235 7.16094 0 8.8908 0ZM12.8423 9.4142C12.2408 10.023 11.8544 10.7787 11.8544 11.6569V15C11.8544 16.1046 10.9699 17 9.87866 17H7.90293C6.8118 17 5.92724 16.1046 5.92724 15V11.6569C5.92724 10.7787 5.5408 10.023 4.93937 9.4142V15.5858C4.93937 16.2261 5.19063 16.8401 5.63789 17.2929C6.08516 17.7456 6.69177 18 7.32434 18H10.4574C11.0899 18 11.6965 17.7456 12.1437 17.2929C12.591 16.8401 12.8423 16.2261 12.8423 15.5858V9.4142ZM8.8908 2C7.60993 2 6.53045 2.43978 5.7639 2.88923C5.2582 3.18573 4.93937 3.82377 4.93937 4.65685V5.21609C5.29593 5.03175 5.65912 4.85819 6.02238 4.70336C6.94885 4.30847 7.95618 4 8.8908 4C9.82552 4 10.8327 4.30847 11.7593 4.70336C12.1225 4.85819 12.4857 5.03175 12.8423 5.21609V4.65685C12.8423 3.82377 12.5235 3.18573 12.0178 2.88923C11.2512 2.43978 10.1718 2 8.8908 2Z"
              fill="black"/>
    </svg>
)

const PrestazioniIcon = (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M18.485 0.0374898C19.3773 -0.185603 20.1856 0.622687 19.9625 1.51504L18.7384 6.41122C18.495 7.38503 17.9915 8.27441 17.2818 8.9842L12.208 14.0578V16.5025C12.208 16.9432 12.033 17.3657 11.7214 17.6774L9.80561 19.5932C9.14246 20.2564 8.03119 20.0829 7.59573 19.2605C7.31299 18.7265 6.7564 17.7231 6.10957 16.7695C6.00146 17.041 5.83751 17.2954 5.61775 17.5151C4.75262 18.3803 1.11416 19.2774 0.918355 19.0816C0.722543 18.8859 1.61968 15.2474 2.48482 14.3822C2.70459 14.1625 2.95904 13.9986 3.23055 13.8905C2.27699 13.2436 1.27354 12.687 0.739524 12.4042C-0.0829133 11.9688 -0.256373 10.8576 0.406783 10.1944L2.3226 8.27862C2.6342 7.96704 3.0568 7.79191 3.49745 7.79191H5.94218L11.0158 2.7183C11.7256 2.00852 12.615 1.50498 13.5888 1.26153L18.485 0.0374898ZM16.2733 6.67634C15.9937 6.14158 15.5919 5.55891 15.0165 4.98356C14.4412 4.40818 13.8584 4.00644 13.3236 3.72668C13.0528 3.87645 12.8032 4.064 12.5823 4.2848L11.4903 5.37689C11.9312 5.48819 12.6754 5.77544 13.45 6.55002C14.2246 7.32455 14.5118 8.06883 14.6232 8.50979L15.7152 7.41773C15.9361 7.19692 16.1236 6.94713 16.2733 6.67634Z"
              fill="black"/>
    </svg>
)

const ConsumiIcon = (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M1.05263 2.45792C1.05263 1.26781 1.99519 0.30304 3.15789 0.30304H11.5789C12.7417 0.30304 13.6842 1.26781 13.6842 2.45792V10H14.7368C15.8996 10 16.8421 10.9648 16.8421 12.1549V14.8485C16.8421 15.146 17.0778 15.3872 17.3684 15.3872C17.6591 15.3872 17.8947 15.146 17.8947 14.8485V8.2914L16.5789 6.94461L16.5338 6.99084C16.1227 7.4116 15.4562 7.4116 15.0452 6.99084C14.6341 6.57006 14.6341 5.88787 15.0452 5.4671L15.0903 5.42088L15.0452 5.37467C14.6341 4.9539 14.6341 4.27171 15.0452 3.85093C15.4562 3.43017 16.1227 3.43017 16.5338 3.85093L19.3834 6.76769C19.7782 7.1718 20 7.71991 20 8.2914V14.8485C20 16.3361 18.8218 17.5421 17.3684 17.5421C15.9151 17.5421 14.7368 16.3361 14.7368 14.8485V12.1549H13.6842V17.5421C14.2656 17.5421 14.7368 18.0245 14.7368 18.6195C14.7368 19.2146 14.2656 19.697 13.6842 19.697H1.05263C0.471284 19.697 0 19.2146 0 18.6195C0 18.0245 0.471284 17.5421 1.05263 17.5421V2.45792ZM8.30993 6.17209C8.56989 5.63986 8.35915 4.99267 7.83917 4.72655C7.3192 4.46043 6.68691 4.67617 6.42692 5.2084L4.32927 9.50255C3.97583 10.2261 4.48983 11.0775 5.28019 11.0775H7.7705L6.42692 13.8279C6.16693 14.3602 6.37769 15.0073 6.89767 15.2734C7.41764 15.5396 8.04994 15.3239 8.30993 14.7916L10.4076 10.4975C10.7611 9.77386 10.2469 8.92257 9.45663 8.92257H6.96635L8.30993 6.17209Z"
              fill="black"/>
    </svg>

)

const CarSpecsTable = ({car}: CarSpecsTableProps) => {
    const [openSection, setOpenSection] = useState<string | null>(null);

    const toggleSection = (section: string) => {
        setOpenSection(prevSection => (prevSection === section ? null : section));
    };


    const sections = [
        {
            title: 'Motore',
            icon: MotoreIcon,
            specs: [
                {label: 'Cilindrata', value: car.cilindrata ? `${car.cilindrata} cc` : '-'},
                {label: 'Cilindri', value: car.cilindri || '-'},
                {label: 'Marce', value: car.numeroMarce || '-'},
                {label: 'Alimentazione', value: car.alimentazione || '-'},
                {label: 'Kw - cv', value: (car.kw && car.cv) ? `${car.kw} kW - ${car.cv} CV` : '-'},
                {label: 'Coppia', value: car.coppia ? `${car.coppia} Nm` : '-'},
                {label: 'Max Potenza', value: car.rpmCoppiaMax ? `${car.rpmCoppiaMax} giri/min` : '-'},
                {label: 'Cambio', value: car.cambio || '-'},
                {label: 'Trazione', value: car.trazione || '-'},
            ],
        },
        {
            title: 'Carrozzeria',
            icon: CarrozzeriaIcon,
            specs: [
                {label: 'Altezza', value: car.altezza ? `${car.altezza} mm` : '-'},
                {label: 'Larghezza', value: car.larghezza ? `${car.larghezza} mm` : '-'},
                {label: 'Lunghezza', value: car.lunghezza ? `${car.lunghezza} mm` : '-'},
                {label: 'Serbatoio', value: car.volumeSerbatoio ? `${car.volumeSerbatoio} L` : '-'},
                {label: 'Numero Porte', value: car.porte || '-'},
                {label: 'Carrozzeria', value: car.categoria || '-'},
                {label: 'Massa Max', value: car.pesoMax ? `${car.pesoMax} kg` : '-'},
                {label: 'Volume carico', value: car.volumeBagagliaio ? `${car.volumeBagagliaio} L` : '-'},
                {label: 'Numero posti', value: car.posti || '-'},
                {label: 'Colore', value: car.colore || '-'},
            ],
        },
        {
            title: 'Prestazioni',
            icon: PrestazioniIcon,
            specs: [
                {label: 'Velocità Max', value: car.velocitaMax ? `${car.velocitaMax} Km/h` : '-'},
                {label: 'Accelerazione 0-100 Km/h', value: car.accelerazione ? `${car.accelerazione} s` : '-'},
            ],
        },
        {
            title: 'Consumi dichiarati',
            icon: ConsumiIcon,
            specs: [
                {label: 'Urbano', value: car.consumoUrbano ? `${car.consumoUrbano} L/100Km` : '-'},
                {label: 'ExtraUrbano', value: car.consumoExtraUrbano ? `${car.consumoExtraUrbano} L/100Km` : '-'},
                {label: 'Misto', value: car.consumoMisto ? `${car.consumoMisto} L/100Km` : '-'},
                {label: 'Emissioni Co2', value: car.emissioni ? `${car.emissioni} g/km` : '-'},
                {label: 'Omologazione', value: car.omologazione || '-'},
            ],
        },
    ];

    return (
        <>
            <div className="bg-white/40 p-4 rounded-lg shadow-md grid grid-cols-4 gap-x-10 max-lg:hidden">
                {sections.map((section, index) => (
                    <div key={index}>
                        <h3 className="text-lg font-bold mb-2 px-2 flex  items-center">
                            <span className="mr-2">{section.icon}</span>
                            {section.title}
                        </h3>
                        <ul>
                            {section.specs.map((spec, idx) => (
                                <li
                                    key={idx}
                                    className={`text-sm flex justify-between my-1 text-gray-700 ${idx % 2 === 0 ? 'bg-transparent' : 'bg-[#000D7D]/5'} px-2 py-0.5 rounded-md`}
                                >
                                    <strong>{spec.label}:</strong> {spec.value}
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </div>

            <div className="bg-white/40 p-4 rounded-lg shadow-md max-lg:shadow-none lg:hidden">
                {sections.map((section, index) => (
                    <div key={index} className="mb-4">
                        <button
                            onClick={() => toggleSection(section.title)}
                            className="w-full flex items-center justify-between px-4 py-2 text-lg font-bold border border-[#000D7D] rounded-lg"
                        >
                        <span className="flex items-center">
                            <span className="mr-2">{section.icon}</span>
                            {section.title}
                        </span>
                            <span>{openSection === section.title ? <ChevronUp/> : <ChevronDown/>}</span>
                        </button>
                        {openSection === section.title && (
                            <ul className="px-4 py-2 ">
                                {section.specs.map((spec, idx) => (
                                    <li
                                        key={idx}
                                        className={`text-sm flex justify-between my-1 text-gray-700 ${idx % 2 === 0 ? 'bg-transparent' : 'bg-[#000D7D]/5'} px-2 py-0.5 rounded-md`}
                                    >
                                        <strong>{spec.label}:</strong> {spec.value}
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                ))}
            </div>
        </>
    );
};

export default CarSpecsTable;
